module.exports = __webpack_public_path__ + "static/media/ShellHacks-title.156dca42.svg";